import React from "react";
import { useUiPack } from "@/hooks/useUiPack";
import TableManagement from "@/pages/TableManagement";
import SimpleTables from "@/pages/simple/SimpleTables";

export default function UiPackTables() {
  const { isSimple } = useUiPack();
  return isSimple ? <SimpleTables /> : <TableManagement />;
}
